<div class="panel-outter">
    <div class="header">
        <div class="title" trans>Roles</div>
        <div class="add-button" *ngIf="!readonly">
            <button mat-flat-button color="accent" class="select-roles-modal-button" (click)="openSelectRolesModal()" type="button" trans>Add</button
        ></div>
    </div>
    <div class="panel-body roles">
        <div class="no-permissions" *ngIf="!user.roles || !user.roles.length" trans>No roles yet.</div>

        <mat-chip-list [selectable]="false">
            <mat-chip (removed)="detachRoles([role.id])" [removable]="true" *ngFor="let role of user.roles" [disabled]="readonly">
                <span>{{role.name}}</span>
                <mat-icon svgIcon="cancel" matChipRemove></mat-icon>
            </mat-chip>
        </mat-chip-list>
    </div>
</div>

<permissions-manager-panel [permissions]="user.permissions" (change)="user.permissions = $event"></permissions-manager-panel>